import { Key } from '@briebug/ngrx-auto-entity';

export class RestorationCategory {
  @Key id?: number;
  name: string;
  delta: number;
}
